<template>
  <div style="position: relative">
    <div
      style="
        max-width: 600px;
        margin: 0 auto;
        min-height: 500px;
        position: relative;
        background: white;
      "
      v-loading="isLoading"
      :element-loading-text="loadingTxt"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255, 1)"
    >
      <PvError v-if="vista === 'error'" />
      <menuTabs :datos="pedido" v-if="pedido && !isMobile" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { HTTP } from "@/axios";
import { EventBus } from "@/event-bus.js";

export default {
  name: "postVenta",
  components: {
    menuTabs: () => import("@/components/menuTabs"),
    PvError: () => import("@/components/error"),
  },
  watch: {
    $route(to, from) {
      console.log("to", to.params.pedido);
      console.log("from", from.params.pedido);
      this.vtex_id = to.params.pedido;
      this.isLoading = true;
      setTimeout(() => {
        this.getInfoPedido();
        this.vuexLoadDatos({ pedido: this.vtex_id });
        
      }, 100);
       
    },
  },
  data() {
    return {
      isMobile: false,
      isLoading: true,
      loadingTxt: "Recuperando información...",
      vtex_id: this.$route.params.pedido ? this.$route.params.pedido : 0,
      pedido: null,
      vista: undefined,
      options: {
        lockScroll: false,
      },
    };
  },
  mounted() {},
  computed: {
    ...mapGetters([
      // 'isLoading',
      "datos",
      "cabecera",
      "pedidoCancelado",
      "textoCancelandoPedido",
      "mostrarChat",
    ]),
  },
  created() {
    this.getInfoPedido();
    this.vuexLoadDatos({ pedido: this.vtex_id });
    EventBus.$on("isMobile", (opt) => {
      this.isMobile = opt;
    });
  },

  methods: {
    ...mapActions({
      vuexLoadDatos: "loadDatos",
      vuexGetDataVtex: "getDataVtex",
    }),
    getInfoPedido(p) {
      HTTP.post("/getInfoPedido", { vtex_id: this.vtex_id })
        .then(({ data }) => {
          console.log("ticket", data);
          if (data) {
            this.error = false;
            this.isLoading = false
            this.pedido = data.pedido;
          } else {
            this.buscarOrden = false;
            if (this.buscadorIdVtex) {
              this.$alert("Verifique el número de orden vtex", "Sin datos", this.options);
            }
          }

          // if (data) {
          //   this.pedido = data;
          //   this.vuexLoadDatos({ pedido: data });
          //   this.getPuntoRetiro({ id: data });
          //   this.getInformation({ id: data });
          //   this.error = false;
          // } else {
          //   // console.log('ERROR!');
          //   this.buscadorIdVtex = "";
          //   this.error = true;
          //   // this.inputFocus("inputNombre");
          // }
        })
        .catch((err) => console.log("error!!", err));
    },
    verificarIdVtex() {
      HTTP.post("/verificarIdVtex", { vtex_id: this.pedido })
        .then(({ data }) => {
          console.log("pedido", data);
          if (!data) window.location.replace("#/404");
        })
        .catch((err) => console.log("err", err));
    },

    cerrarChat() {
      this.$alert("Cerrar el reclamo", "Finalizar reclamo / consulta", this.options);
    },
  },
};
</script>
<style lang="scss">
.btnAyuda {
  float: left;

  border-radius: 0px !important;
  position: fixed;
  width: 100%;
  left: 0;
  top: 92.2%;
  padding: 20px !important;
  z-index: 999;
  border-top:1px solid #e3e3e3;
}
.el-loading-spinner i {
  color: #cdc928 !important;
}
.el-loading-spinner .el-loading-text {
  color: #cdc928 !important;
  font-size: 13.5px;
  margin: 3px 0;
}

.pv-chat-options {
  margin: 0 auto;
  padding: 20px 0px;
  width: 85%;
}
// .pv-options {
//   background: #fadedc;
//   border: 1px solid #fadedc;
//   max-height: 595px;
//   height: 100vh;
//   position: relative;
// }
.pv-main {
  background: #fff;
}
.el-loading-spinner i {
  color: #cdc928 !important;
}
.el-loading-spinner .el-loading-text {
  color: #cdc928 !important;
  font-size: 13.5px;
  margin: 3px 0;
}

.pv-motivos {
  -moz-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  -webkit-backface-visibility: hidden;
  -webkit-transition: 0.3s ease-in-out;
  backface-visibility: hidden;
  background: white;
  border: 0px !important;
  border-radius: 4px;
  box-shadow: 1px 1px 2px 0px #b7aaaa;
  box-sizing: border-box;
  color: #000;
  font-weight: 500;
  height: 58px !important;
  margin-top: 10px;
  padding: 20px !important;
  text-align: left;
  transition: 0.3s ease-in-out;
  transition: all 0.2s;
  width: 100%;
}
.pv-motivos:hover {
  transform: scale(1.05);
}
.el-radio,
.el-radio__input {
  line-height: 1;
  outline: 0;
  white-space: normal !important;
  word-break: break-word !important;
}
.pv-motivos .el-radio__inner {
  background-color: #fadedc;
  border: 1px solid #ffc4c0;
  border-radius: 100%;
  box-sizing: border-box;
  cursor: pointer;
  height: 14px;
  width: 14px;
}
.modal-inner > .el-dialog__header {
  visibility: hidden;
}
.modal-inner {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
}
.modal-inner small {
  font-weight: normal;
}
@media screen and (max-width: 768px) {
  .pv-main {
    border-left: none;
  }
  .pv-options {
    max-height: 100vh;
  }
}
</style>
